// extracted by mini-css-extract-plugin
export var barMenuItem = "footer-bar-menu-module--barMenuItem--fa+9u";
export var barMenuLabel = "footer-bar-menu-module--barMenuLabel--1pEIo";
export var barMenuSeparator = "footer-bar-menu-module--barMenuSeparator--6680Y";
export var collapsibleContentBottomMenu = "footer-bar-menu-module--collapsibleContentBottomMenu--Soxli";